import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { resources } from '../../../resources/resources';

export default function Legal() {
  const { t: translate } = useTranslation();

  return (
    <div className="footer-legal footer-nav">
      <ul>
        <li>
          <Link
            to="/termeni-si-conditii"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate(resources.footer.termsAndConditions)}
          </Link>
        </li>
        <li>
          <Link
            to="/politica-prelucrare-date-personale"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate(resources.footer.personalData)}
          </Link>
        </li>
        <li>
          <Link
            to="/politica-cookies"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate(resources.footer.cookies)}
          </Link>
        </li>
        <li>
          <Link
            to="/exercitare-drepturi-gdpr"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate(resources.footer.gDPR)}
          </Link>
        </li>
        <li>
          <Link to="/accesibilitate" target="_blank" rel="noopener noreferrer">
            {translate(resources.footer.accessibility)}
          </Link>
        </li>
      </ul>
    </div>
  );
}
